import React, { Component } from 'react';
import golbeldata from '../data.json';
import Appnav from './Appnav.js'
import AppFooter from './Footer.js'
import AppTopHeader from './AppTopHeader.js'
import { Link, Route, Switch } from 'react-router-dom';

class Reservation extends Component {
  constructor(props) {
    super(props);

    this.concerts = golbeldata;
  }

  componentDidMount() {

    document.title = this.concerts.HotelName+" Reservation";
    window.jQuery("#owl-standard").owlCarousel({
      navigation: true,
      // Show next and prev buttons
      slideSpeed: 300,
      paginationSpeed: 400,
      singleItem: true,
      pagination: false,
      navigationText: ['<i class="fa fa-angle-left fa-3x"></i>', '<i class="fa fa-angle-right fa-3x"></i>'],
      responsive: true,
      responsiveRefreshRate: 200,
      responsiveBaseWidth: window,
      // "singleItem:true" is a shortcut for:
      // items : 1, 
      // itemsDesktop : false,
      // itemsDesktopSmall : false,
      // itemsTablet: false,
      // itemsMobile : false
    });
    if (window.jQuery().prettyPhoto) {
      window.jQuery('a[data-rel]').each(function () {
        window.jQuery(this).attr('rel', window.jQuery(this).data('rel'));
      });

      window.jQuery("a[rel^='prettyPhoto']").prettyPhoto({
        social_tools: false,
        animation_speed: 'normal', // fast/slow/normal 
        slideshow: 5000, // false OR interval time in ms
        autoplay_slideshow: false, // true/false
        opacity: 0.80, // Value between 0 and 1 
        show_title: true, // true/false            
        allow_resize: true, // Resize the photos bigger than viewport. true/false
        default_width: 500,
        default_height: 344,
        counter_separator_label: '/', // The separator for the gallery counter 1 "of" 2
        theme: 'pp_default', // light_rounded / dark_rounded / light_square / dark_square / facebook
        horizontal_padding: 20, // The padding on each side of the picture 
        hideflash: false, // Hides all the flash object on a page, set to TRUE if flash appears over prettyPhoto
        wmode: 'opaque', // Set the flash wmode attribute
        autoplay: true, // Automatically start videos: True/False 
        modal: false, // If set to true, only the close button will close the window
        deeplinking: true, // Allow prettyPhoto to update the url to enable deeplinking. 
        overlay_gallery: true, // If set to true, a gallery will overlay the fullscreen image on mouse over 
        keyboard_shortcuts: true, // Set to false if you open forms inside prettyPhoto 
        changepicturecallback: function () { }, // Called everytime an item is shown/changed 
        callback: function () { }, // Called when prettyPhoto is closed
      });
    }
  }

  render() {
    console.log(this.concerts.HotelName);
    return (
      <div>
        <AppTopHeader data={this.concerts} />
        <header>
          <Appnav data={this.concerts} />
        </header>
        <section class="parallax-effect">
          <div id="parallax-pagetitle" style={{ backgroundImage: 'url("images/parallax/' + this.concerts.parllex + '")' }}>
            <div class="color-overlay">

              <div class="container">
                <div class="row">
                  <div class="col-sm-12">
                    <ol class="breadcrumb">
                      <li><a href="index.html">Home</a></li>
                      <li class="active">Reservation</li>
                    </ol>
                    <h1>Reservation</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="container mt50">
          <div class="row">
            <section class="standard-slider room-slider">
              <div class="col-sm-12 col-md-8">
                <div id="owl-standard" class="owl-carousel">
                  {
                    this.concerts.ReservationSliderImages.map(function (item) {
                      return <div class="item"> <a href={'images/gallery/reservations/' + item.Path} data-rel="prettyPhoto[gallery1]"><img src={'images/gallery/reservations/' + item.Path}  alt="Image 2" class="img-responsive" /></a> </div>;
                    })
                  }
                </div>
              </div>
            </section>
            <section id="reservation-form" class="mt50 clearfix">
              <div class="col-sm-12 col-md-4">
                <form class="reservation-vertical clearfix" role="form" method="post" action="php/reservation.php" name="reservationform" id="reservationform">
                  <h2 class="lined-heading"><span>Reservation</span></h2>
                  <div id="message"></div>
                  <div class="form-group">
                    <label for="email" accesskey="E">E-mail</label>
                    <input name="email" type="text" id="email" value="" class="form-control" placeholder="Please enter your E-mail" />
                  </div>
                  <div class="form-group">
                    <select class="hidden" name="room" id="room" disabled="disabled">
                      <option selected="selected">Double Room</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="checkin">Check-in</label>
                    <div class="popover-icon" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="right" data-content="Check-In is from 11:00"> <i class="fa fa-info-circle fa-lg"> </i> </div>
                    <i class="fa fa-calendar infield"></i>
                    <input name="checkin" type="text" id="checkin" value="" class="form-control" placeholder="Check-in" />
                  </div>
                  <div class="form-group">
                    <label for="checkout">Check-out</label>
                    <div class="popover-icon" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="right" data-content="Check-out is from 12:00"> <i class="fa fa-info-circle fa-lg"> </i> </div>
                    <i class="fa fa-calendar infield"></i>
                    <input name="checkout" type="text" id="checkout" value="" class="form-control" placeholder="Check-out" />
                  </div>
                  <div class="form-group">
                    <div class="guests-select">
                      <label>Guests</label>
                      <i class="fa fa-user infield"></i>
                      <div class="total form-control" id="test">1</div>
                      <div class="guests">
                        <div class="form-group adults">
                          <label for="adults">Adults</label>
                          <div class="popover-icon" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="right" data-content="+18 years"> <i class="fa fa-info-circle fa-lg"> </i> </div>
                          <select name="adults" id="adults" class="form-control">
                            <option value="1">1 adult</option>
                            <option value="2">2 adults</option>
                            <option value="3">3 adults</option>
                          </select>
                        </div>
                        <div class="form-group children">
                          <label for="children">Children</label>
                          <div class="popover-icon" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="right" data-content="0 till 18 years"> <i class="fa fa-info-circle fa-lg"> </i> </div>
                          <select name="children" id="children" class="form-control">
                            <option value="0">0 children</option>
                            <option value="1">1 child</option>
                            <option value="2">2 children</option>
                            <option value="3">3 children</option>
                          </select>
                        </div>
                        <button type="button" class="btn btn-default button-save btn-block">Save</button>
                      </div>
                    </div>
                  </div>
                  <button type="submit" class="btn btn-primary btn-block">Book Now</button>
                </form>
              </div>
            </section>
          </div>
        </div>


        <section class="rooms mt50">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">
                <h2 class="lined-heading"><span>Other rooms</span></h2>
              </div>
              {
                this.concerts.Roomhome.map(function (item) {
                  return <div class="col-sm-4 ">
                    <div class="room-thumb"> <img src={'images/rooms/Thumblarge/' + item.Path} alt="room 1" class="img-responsive" />
                      <div class="mask">
                        <div class="main">
                          <h5>{item.heading}</h5>
                          <div class="price">{item.Price}</div>
                        </div>
                        <div class="content">
                          <p><span>{item.Title}</span> {item.Description}</p>
                          <div class="row">
                            <div class="col-xs-6">
                              <ul class="list-unstyled">
                                <li><i class="fa fa-check-circle"></i> Laundry</li>
                                <li><i class="fa fa-check-circle"></i> Bathroom</li>
                              </ul>
                            </div>
                            <div class="col-xs-6">
                              <ul class="list-unstyled">
                                <li><i class="fa fa-check-circle"></i> Free Wi-Fi</li>
                                <li><i class="fa fa-check-circle"></i> Incl. breakfast</li>

                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>;
                })
              }

            </div>
          </div>
        </section>
        <AppFooter data={this.concerts} />
        <div id="go-top"><i class="fa fa-angle-up fa-2x"></i></div>

      </div>
    )
  }
}
export default Reservation;


// WEBPACK FOOTER //
// ./src/components/Reservation.js